var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 57,
    viewBox: "0 0 70 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.042 47.2881C35.6511 47.6808 35.0155 47.6808 34.6246 47.2881L24.1869 36.8034C23.4935 36.1069 22.9436 35.2801 22.5683 34.3702C22.1931 33.4602 22 32.485 22 31.5C22 30.5151 22.1931 29.5398 22.5683 28.6299C22.9436 27.7199 23.4935 26.8932 24.1869 26.1967C24.8802 25.5003 25.7033 24.9478 26.6091 24.5709C27.515 24.194 28.4859 24 29.4664 24C30.4469 24 31.4178 24.194 32.3237 24.5709C33.2296 24.9478 34.0527 25.5003 34.746 26.1967V26.1967C35.0699 26.5221 35.5967 26.5221 35.9207 26.1967V26.1967C36.614 25.5003 37.4371 24.9478 38.343 24.5709C39.2488 24.194 40.2197 24 41.2002 24C42.1808 24 43.1517 24.194 44.0575 24.5709C44.9634 24.9478 45.7865 25.5003 46.4798 26.1967C47.1731 26.8932 47.7231 27.7199 48.0983 28.6299C48.4735 29.5398 48.6667 30.5151 48.6667 31.5C48.6667 32.485 48.4735 33.4602 48.0983 34.3702C47.7231 35.2801 47.1731 36.1069 46.4798 36.8034L36.042 47.2881Z",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 28.5V47C8.99995 51.4183 12.5817 55 17 55H53C57.4182 55 61 51.4183 61 47V28.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35L35 2L68 35",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelected);
export default __webpack_public_path__ + "static/media/homeSelected.499be01d.svg";
export { ForwardRef as ReactComponent };